import {
    BUSINESS_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_IMAGES,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import {
    CategoryScrollTemplate,
    HorizontalSlider,
    HorizontalSliderCard,
} from '@eventbrite/category-scroll';
import { track } from '@eventbrite/datalayer-library';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { logEvent } from '@eventbrite/statsig';
import { getPlaceFromCoordinates } from '@eventbrite/user-location';
import React, { useEffect, useState } from 'react';
import { LISTING_HEAP_IDS } from '../../constants';
import { Location } from '../../types/index';
import './CategoryBrowseHorizontalSlider.scss';
export const CategoryBrowseHorizontalSlider = (location: Location) => {
    interface Category {
        key: string;
        name: string | GenericLazyString;
        imageUrl: any;
    }

    const [locationSlug, setLocationSlug] = useState('online');

    useEffect(() => {
        getPlaceFromCoordinates(location).then((place) => {
            if (place) setLocationSlug(place.location_slug);
        });
    }, [location]);

    const CATEGORY_KEYS = [
        MUSIC_EVENTBRITE_CATEGORY,
        PERFORMING_EVENTBRITE_CATEGORY,
        SEASONAL_EVENTBRITE_CATEGORY,
        HEALTH_EVENTBRITE_CATEGORY,
        HOBBIES_EVENTBRITE_CATEGORY,
        BUSINESS_EVENTBRITE_CATEGORY,
        FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        SPORTS_EVENTBRITE_CATEGORY,
    ];

    const CATEGORIES: Category[] = CATEGORY_KEYS.map((category) => {
        return {
            key: EVENTBRITE_CATEGORY_TO_REFINEMENT[category],
            name: EVENTBRITE_CATEGORY_MAPPING[category],
            imageUrl: EVENTBRITE_CATEGORY_IMAGES[category],
        };
    });

    useEffect(() => {
        track({
            eventName: LISTING_HEAP_IDS.IMAGE_CATEGORY_VIEW,
            eventData: {},
        });
    }, []);

    return (
        <div className="confettiImage">
            <CategoryScrollTemplate
                title={gettext('This event has ended')}
                subTitle={gettext(
                    'Find something to do, explore our top categories.',
                )}
                wrappingClasses="noPadding"
            >
                <HorizontalSlider cards={CATEGORIES}>
                    {(category) => {
                        return (
                            <a
                                data-heap-id={
                                    LISTING_HEAP_IDS.IMAGE_CATEGORY_CLICK
                                }
                                key={category?.key}
                                href={`/d/${locationSlug}/${category?.key}--events/${category?.key}`}
                                onClick={() => {
                                    logEvent(
                                        LISTING_HEAP_IDS.IMAGE_CATEGORY_CLICK,
                                    );
                                    typeof window !== 'undefined'
                                        ? window.scrollTo(0, 0)
                                        : null;
                                }}
                            >
                                <HorizontalSliderCard
                                    title={category?.name || ''}
                                    imageUrl={category?.imageUrl}
                                    imageLoading={'lazy'}
                                />
                            </a>
                        );
                    }}
                </HorizontalSlider>
            </CategoryScrollTemplate>
        </div>
    );
};
